<div (click)="deleteItem.emit()" class="delete-item">
  {{ itemName }} <tp-icon class="delete-item__icon" name="icons/delete"></tp-icon>
</div>
